/* eslint-disable radix */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-else-return */
/* eslint-disable react/prop-types */
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';

export const FORM_TEST_RESULT_ID = 'form-test-result--id';
export const adultType = 2;
export const childType = 1;

export const kidConfGrade = [
  {
    maxPoint: 5,
    label: 'Pre-A1',
  },
  {
    maxPoint: 10,
    label: 'Upper Pre-A1',
  },
  {
    maxPoint: 15,
    label: 'A1',
  },
  {
    maxPoint: 20,
    label: 'Upper A1',
  },
  {
    maxPoint: 25,
    label: 'A2',
  },
  {
    maxPoint: 30,
    label: 'Upper A2',
  },
];

export const adultConfGrade = [
  {
    maxPoint: 1.25,
    label: 'A0 (Starter)',
  },
  {
    maxPoint: 2.75,
    label: 'A1 (Beginner)',
  },
  {
    maxPoint: 3.5,
    label: 'A2 (Elementary)',
  },
  {
    maxPoint: 5,
    label: 'B1 (Intermediate)',
  },
  {
    maxPoint: 6.5,
    label: 'B2 (Upper Intermediate)',
  },
  {
    maxPoint: 8,
    label: 'C1 (Advanced)',
  },
  {
    maxPoint: 9,
    label: 'C2 (Profiency)',
  },
];

export const FORM_DEFAULT_VALUES = (isAdult: boolean) => ({
  fluency1: '',
  fluency1Score: 0,
  fluency2: '',
  fluency2Score: 0,
  fluency3: '',
  fluency3Score: 0,
  lexical1: '',
  lexical1Score: 0,
  lexical2: '',
  lexical2Score: 0,
  lexical3: '',
  lexical3Score: 0,
  grammatical1: '',
  grammatical1Score: 0,
  grammatical2: '',
  grammatical2Score: 0,
  grammatical3: '',
  grammatical3Score: 0,
  pronunciation1: '',
  pronunciation1Score: 0,
  pronunciation2: '',
  pronunciation2Score: 0,
  pronunciation3: '',
  pronunciation3Score: 0,
  personalCriteria1: '',
  personalCriteria2: '',
  comment1: '',
  comment2: '',
  comment3: '',
  sumScore: '',
  testType: isAdult ? adultType : childType,
});
export const FORM_DEFAULT_VALUES_TEENAGERS = (isAdult: boolean) => ({
  fluency1: undefined,
  fluency1Score: 0,
  fluency2: undefined,
  fluency2Score: undefined,
  fluency3: undefined,
  fluency3Score: undefined,
  lexical1: undefined,
  lexical1Score: undefined,
  lexical2: undefined,
  lexical2Score: undefined,
  lexical3: isAdult ? undefined : '',
  lexical3Score: isAdult ? undefined : 0,
  grammatical1: undefined,
  grammatical1Score: undefined,
  grammatical2: undefined,
  grammatical2Score: undefined,
  grammatical3: undefined,
  grammatical3Score: undefined,
  pronunciation1: undefined,
  pronunciation1Score: undefined,
  pronunciation2: undefined,
  pronunciation2Score: undefined,
  pronunciation3: isAdult ? undefined : '',
  pronunciation3Score: isAdult ? undefined : 0,
  personalCriteria1: undefined,
  personalCriteria2: undefined,
  comment1: undefined,
  comment2: undefined,
  comment3: undefined,
  sumScore: undefined,
  testType: isAdult ? adultType : childType,
});
export const SCHEMA = (isAdult: boolean) => {
  const maxValue = isAdult ? 9 : 3;
  return yup.object().shape({
    fluency1: yup
      .string()
      .min(30, 'This field must be at least 30 characters')
      .required(() => (
        <FormattedMessage defaultMessage="This Field Is Require" />
      )),
    fluency1Score: yup
      .number()
      .min(0)
      .max(maxValue)
      .typeError(() => (
        <FormattedMessage defaultMessage="This Field must specify a number" />
      )),
    fluency2: yup
      .string()
      .min(30, 'This field must be at least 30 characters')
      .required(() => (
        <FormattedMessage defaultMessage="This Field Is Require" />
      )),
    fluency2Score: yup
      .number()
      .min(0)
      .max(maxValue)
      .typeError(() => (
        <FormattedMessage defaultMessage="This Field must specify a number" />
      )),
    fluency3: yup
      .string()
      .min(30, 'This field must be at least 30 characters')
      .required(() => (
        <FormattedMessage defaultMessage="This Field Is Require" />
      )),
    fluency3Score: yup
      .number()
      .min(0)
      .max(maxValue)
      .typeError(() => (
        <FormattedMessage defaultMessage="This Field must specify a number" />
      )),
    lexical1: yup
      .string()
      .min(30, 'This field must be at least 30 characters')
      .required(() => (
        <FormattedMessage defaultMessage="This Field Is Require" />
      )),
    lexical1Score: yup
      .number()
      .min(0)
      .max(maxValue)
      .typeError(() => (
        <FormattedMessage defaultMessage="This Field must specify a number" />
      )),
    lexical2: yup
      .string()
      .min(30, 'This field must be at least 30 characters')
      .required(() => (
        <FormattedMessage defaultMessage="This Field Is Require" />
      )),
    lexical2Score: yup
      .number()
      .min(0)
      .max(maxValue)
      .typeError(() => (
        <FormattedMessage defaultMessage="This Field must specify a number" />
      )),
    lexical3: yup.string().when('testType', {
      is: adultType,
      then: yup
        .string()
        .min(30, 'This field must be at least 30 characters')
        .required(() => (
          <FormattedMessage defaultMessage="This Field Is Require" />
        )),
    }),
    lexical3Score: yup
      .number()
      .min(0)
      .max(maxValue)
      .when('testType', {
        is: adultType,
        then: yup
          .number()
          .typeError(() => (
            <FormattedMessage defaultMessage="This Field must specify a number" />
          )),
      }),
    grammatical1: yup
      .string()
      .min(30, 'This field must be at least 30 characters')
      .required(() => (
        <FormattedMessage defaultMessage="This Field Is Require" />
      )),
    grammatical1Score: yup
      .number()
      .min(0)
      .max(maxValue)
      .typeError(() => (
        <FormattedMessage defaultMessage="This Field must specify a number" />
      )),
    grammatical2: yup
      .string()
      .min(30, 'This field must be at least 30 characters')
      .required(() => (
        <FormattedMessage defaultMessage="This Field Is Require" />
      )),
    grammatical2Score: yup
      .number()
      .min(0)
      .max(maxValue)
      .typeError(() => (
        <FormattedMessage defaultMessage="This Field must specify a number" />
      )),
    grammatical3: yup
      .string()
      .min(30, 'This field must be at least 30 characters')
      .required(() => (
        <FormattedMessage defaultMessage="This Field Is Require" />
      )),
    grammatical3Score: yup
      .number()
      .min(0)
      .max(maxValue)
      .typeError(() => (
        <FormattedMessage defaultMessage="This Field must specify a number" />
      )),
    pronunciation1: yup
      .string()
      .min(30, 'This field must be at least 30 characters')
      .required(() => (
        <FormattedMessage defaultMessage="This Field Is Require" />
      )),
    pronunciation1Score: yup
      .number()
      .min(0)
      .max(maxValue)
      .typeError(() => (
        <FormattedMessage defaultMessage="This Field must specify a number" />
      )),
    pronunciation2: yup
      .string()
      .min(30, 'This field must be at least 30 characters')
      .required(() => (
        <FormattedMessage defaultMessage="This Field Is Require" />
      )),
    pronunciation2Score: yup
      .number()
      .min(0)
      .max(maxValue)
      .typeError(() => (
        <FormattedMessage defaultMessage="This Field must specify a number" />
      )),
    pronunciation3: yup.string().when('testType', {
      is: adultType,
      then: yup
        .string()
        .min(30, 'This field must be at least 30 characters')
        .required(() => (
          <FormattedMessage defaultMessage="This Field Is Require" />
        )),
    }),
    pronunciation3Score: yup
      .number()
      .min(0)
      .max(maxValue)
      .when('testType', {
        is: adultType,
        then: yup
          .number()
          .typeError(() => (
            <FormattedMessage defaultMessage="This Field must specify a number" />
          )),
      }),
    personalCriteria1: yup
      .string()
      .min(30, 'This field must be at least 30 characters')
      .required(() => (
        <FormattedMessage defaultMessage="This Field Is Require" />
      )),
    personalCriteria2: yup
      .string()
      .min(30, 'This field must be at least 30 characters')
      .required(() => (
        <FormattedMessage defaultMessage="This Field Is Require" />
      )),
    comment1: yup
      .string()
      .min(150, 'Strengths must be at least 150 characters')
      .required(() => (
        <FormattedMessage defaultMessage="This Field Is Require" />
      )),
    comment2: yup
      .string()
      .min(150, 'Weakness must be at least 150 characters')
      .required(() => (
        <FormattedMessage defaultMessage="This Field Is Require" />
      )),
    comment3: yup
      .string()
      .min(150, 'Recommendation must be at least 150 characters')
      .required(() => (
        <FormattedMessage defaultMessage="This Field Is Require" />
      )),
  });
};
export const SCHEMATEENAGERS = (isAdult: boolean) => {
  const maxValue = !isAdult ? 9 : 3;
  return yup.object().shape({
    fluency1: yup.string(),
    fluency1Score: yup
      .number()
      .max(maxValue)
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    fluency2: yup
      .string()
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    fluency2Score: yup
      .number()
      .max(maxValue)
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    fluency3: yup
      .string()
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    fluency3Score: yup
      .number()
      .max(maxValue)
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    lexical1: yup
      .string()
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    lexical1Score: yup
      .number()
      .max(maxValue)
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    lexical2: yup
      .string()
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    lexical2Score: yup
      .number()
      .max(maxValue)
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    lexical3: yup.string().when('testType', {
      is: adultType,
      then: yup
        .string()
        .required(
          `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
        ),
    }),
    lexical3Score: yup
      .number()
      .max(maxValue)
      .when('testType', {
        is: adultType,
        then: yup
          .number()
          .required(
            `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
          ),
      }),
    grammatical1: yup
      .string()
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    grammatical1Score: yup
      .number()
      .max(maxValue)
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    grammatical2: yup
      .string()
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    grammatical2Score: yup
      .number()
      .max(maxValue)
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    grammatical3: yup
      .string()
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    grammatical3Score: yup
      .number()
      .max(maxValue)
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    pronunciation1: yup
      .string()
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    pronunciation1Score: yup
      .number()
      .max(maxValue)
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    pronunciation2: yup
      .string()
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    pronunciation2Score: yup
      .number()
      .max(maxValue)
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    pronunciation3: yup.string().when('testType', {
      is: adultType,
      then: yup
        .string()
        .required(
          `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
        ),
    }),
    pronunciation3Score: yup
      .number()
      .max(maxValue)
      .when('testType', {
        is: adultType,
        then: yup
          .number()
          .required(
            `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
          ),
      }),
    personalCriteria1: yup
      .string()
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    personalCriteria2: yup
      .string()
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    comment1: yup
      .string()
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    comment2: yup
      .string()
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
    comment3: yup
      .string()
      .required(
        `${(<FormattedMessage defaultMessage="This Field Is Require" />)}`,
      ),
  });
};
